import * as React from "react";
const SvgFlagFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 2a1 1 0 0 1 .707.293L14.415 4H19a1 1 0 0 1 .993.883L20 5v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-.707-.293L9.585 14H6v7a1 1 0 0 1-.883.993L5 22a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z", clipRule: "evenodd" }));
export default SvgFlagFill;
